:host {
  display: block;
  width: 100%;
  margin: 10px 0;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ux-copy {
    color: $color-black;
    font-size: $size-text-tiny;
    white-space: nowrap;
  }
}
